<template>
  <div>
    <vxe-modal v-model="dialogVisible" :before-hide-method="handleClose" width="80%" show-zoom resize transfer>
      <template #title>
        <span>隐患依据</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button @click="handleConfirm" v-if="Opt != 'view'">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form ref="PartInfoRef" :model="PartInfo" :rules="PartInfoRules" size="small" class="singleContent"
                :disabled="Opt == 'view'">
                <el-row :gutter="20" class="row-bg">
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="隐患描述:" prop="troubleDescribe">
                        <el-input id="troubleDescribe" v-model="PartInfo.troubleDescribe" clearable />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="判定依据:" prop="judgment">
                        <el-input id="judgment" v-model="PartInfo.judgment" clearable />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="适合行业:" prop="industry">
                        <el-input id="industry" v-model="PartInfo.industry" clearable />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="row-bg">
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="依据强度:" prop="intension">
                        <el-input id="intension" v-model="PartInfo.intension" clearable />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="隐患等级:" prop="level">
                        <el-input id="level" v-model="PartInfo.level" clearable />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="row-bg">
                  <el-col :span="24">
                    <div class="grid-content bg-purple">
                      <el-form-item label="相关图片:" prop="details">
                        <img @click="imageClick(1, {
                          type: 0,
                          text: ''
                        })" v-if="Opt != 'view'" class="img-item" title="点我添加图片" src="../../assets/images/upload.png"
                          alt="">
                        <div class="img-list">
                          <div style="position: relative;" v-for="img in PartInfo.details" :key="img.resourcesId">
                            <img class="img-item" :src="img.fileUrl" alt="">
                            <el-icon v-if="Opt != 'view'" class="img-delete" @click="deleteImg(img)">
                              <CircleCloseFilled />
                            </el-icon>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
    <SubResourceCenter ref="SubResourceCenterRef" v-model:ResourceCenterDialogVisible="ResourceCenterDialogVisible"
      @close-dialog="ResourceCenterCloseDialog" @handle-cancel="ResourceCenterHandleCancel"
      @handle-confirm="ResourceCenterHandleConfirm"></SubResourceCenter>
  </div>
</template>

<script>
import { DetailDataHiddenTrouble, saveHiddenTrouble } from "@api/ApiHazardBasis";
import SubResourceCenter from "@views/YZResource/SubResourceCenter.vue";
import { toRefs, ref, unref, reactive, onUpdated } from "vue";
import { ElMessage } from "element-plus";

export default {
  name: "hazardBasisEdit",
  components: {
    SubResourceCenter,
  },
  setup(props, content) {
    const PartInfoRef = ref();
    const SubResourceCenterRef = ref();
    const OriginalData = () => {
      return {
        dialogVisible: false,
        Opt: "",
        PartInfoRules: {
          troubleDescribe: [
            {
              required: true,
              message: "请输入隐患描述",
              trigger: "blur",
            }
          ],
          judgment: [
            {
              required: true,
              message: "请输入判定依据",
              trigger: "blur",
            },
          ],
          industry: [
            {
              required: true,
              message: "请输入适合行业",
              trigger: "blur",
            },
            {
              min: 1,
              max: 500,
              message: "长度在1到500之间",
              trigger: "blur",
            },
          ],
          intension: [
            {
              required: true,
              message: "请输入依据强度",
              trigger: "blur",
            },
            {
              min: 1,
              max: 500,
              message: "长度在1到500之间",
              trigger: "blur",
            },
          ],
          level: [
            {
              required: true,
              message: "请输入隐患等级",
              trigger: "blur",
            },
            {
              min: 1,
              max: 500,
              message: "长度在1到500之间",
              trigger: "blur",
            },
          ],
        },
        PartInfo: {
          troubleId: 0,
          troubleDescribe: "",
          judgment: "",
          industry: "",
          intension: "",
          level: "",
          details: []
        },
        ResourceCenterDialogVisible: false,
      };
    };
    let data = reactive(OriginalData());
    //关闭
    const handleClose = () => {
      data.dialogVisible = false;
      Object.assign(data, OriginalData());
      content.emit("close-dialog");
    };
    const ResourceCenterCloseDialog = () => {
      data.ResourceCenterDialogVisible = false;
    };
    const ResourceCenterHandleCancel = () => {
      data.ResourceCenterDialogVisible = false;
    };
    //打开资源弹框入口
    const imageClick = (type, row) => {
      // { GroupTypeCode: "1", GroupTypeName: "图片" },
      // { GroupTypeCode: "2", GroupTypeName: "视频" },
      // { GroupTypeCode: "3", GroupTypeName: "文档" },
      data.ResourceCenterDialogVisible = true;
      var obj = {
        type: [type], //展示的页签
        selectFileType: "1", //选中的文件的类型 1图片，2视频，3文档
        selectId: 0, //选中的文件的id
        isSingle: true, //是否单选
        source: "HazardBasisEdit", //数据来源页面
        row: row, //行
        sourceItem: {}, //资源文件对象
      };
      if (type == "1") {
        obj.selectFileType = "1";
        obj.selectId = row.imageId;
        obj.type = ["1"];
      } else if (type == "2") {
        obj.selectFileType = "2"; //row.fileType == undefined ? '2' : row.fileType
        obj.selectId = row.resourcesId;
        obj.type = ["2", "3"];
      }
      SubResourceCenterRef.value.loading(obj);
    };
    //选择资源文件之后 点击确认的回调事件
    const ResourceCenterHandleConfirm = (obj) => {
      data.ResourceCenterDialogVisible = false;
      const { sourceItem } = obj;
      const imgInfo = data.PartInfo.details.find((item) => item.resourcesId == sourceItem[0].PicLogicalCode);
      if (imgInfo) {
        ElMessage.warning("该图片已存在，请重新选择");
      } else {
        data.PartInfo.details.push({
          resourcesId: sourceItem[0].PicLogicalCode,
          fileName: sourceItem[0].FileName,
          fileUrl: sourceItem[0].ImgSrcNew
        })
      }
    };
    const deleteImg = img => {
      const index = data.PartInfo.details.findIndex(item => item.resourcesId == img.resourcesId)
      data.PartInfo.details.splice(index, 1)
    }
    //关闭
    const handleCancel = () => {
      handleClose();
    };
    //提交
    const handleConfirm = async () => {
      const form = unref(PartInfoRef);
      if (!form) return;
      try {
        form.validate((valid) => {
          if (valid) {
            if (data.Opt == "insert") {
              saveHiddenTrouble(data.PartInfo)
                .then(function (result) {
                  ElMessage.success("新增成功！");
                  // data.Opt = "view";
                  handleClose()
                })
                .catch(({ message }) => {
                  ElMessage.error("新增失败!" + message);
                });
            } else {
              saveHiddenTrouble(data.PartInfo)
                .then(function (result) {
                  ElMessage.success("修改成功！");
                  // data.Opt = "view";
                  handleClose()
                })
                .catch((error) => {
                  ElMessage.error("修改失败!" + error);
                });
            }
          }
        });
      } catch (error) { }
    };
    //初始化页面
    const initDialog = (Opt, row) => {
      data.Opt = Opt;
      data.dialogVisible = true;
      if (row) {
        DetailDataHiddenTrouble(row.id).then(res => {
          data.PartInfo = res;
        })
      }
    };
    onUpdated(() => {
      //清除校验
      const form = unref(PartInfoRef);
      if (!form) return;
      form.clearValidate();
    });

    return {
      ...toRefs(data),
      PartInfoRef,
      handleClose,
      handleCancel,
      handleConfirm,
      initDialog,
      ResourceCenterCloseDialog,
      ResourceCenterHandleCancel,
      ResourceCenterHandleConfirm,
      SubResourceCenterRef,
      imageClick,
      deleteImg
    };
  },
};
</script>

<style lang="scss" scoped>
.img-list {
  display: inline-flex;
  align-items: center;
}

.img-item {
  width: 120px;
  height: 120px;
  margin-right: 8px;
}

.img-delete {
  position: absolute;
  top: -10px;
  right: 4px;

  svg {
    font-size: 16px;
  }
}

.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}

::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}

.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}

.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}

.el-textarea {
  margin: 5px 0;
  width: 100%;
}

.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;

  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}

.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}

.switch-display {
  position: relative;
}

.border-all {
  border: 1px solid #dcdfe6;
}
</style>
